module.exports = __webpack_public_path__ + "static/media/ai-translations-a-lonely-struggle-jun25.f603df23.md";